import { CustomError } from '../../common/errors';
import { Domains } from '../../constants';

export class DomainPreferencesNotFoundError extends CustomError {
  constructor(readonly domain: Domains) {
    super(
      'DomainPreferencesNotFoundError',
      `Couldn't find domain preferences for domain ${domain}`
    );
  }
}

export class DomainPreferencesParsingError extends CustomError {
  constructor(
    readonly domain: Domains,
    readonly parsingErrorMsg: string
  ) {
    super(
      'DomainPreferencesParsingError',
      `Couldn't parse domain preferences for domain ${domain}. Error: ${parsingErrorMsg}`
    );
  }
}

export class DomainPreferencesFetchError extends CustomError {
  constructor(
    readonly domain: Domains,
    readonly error: Error
  ) {
    super(
      'DomainPreferencesFetchError',
      `Couldn't fetch domain preferences for domain ${domain}. Error: ${error.message}`
    );
  }
}

export class DomainPreferencesUpdateError extends CustomError {
  constructor(
    readonly domain: Domains,
    readonly error: Error
  ) {
    super(
      'DomainPreferencesFetchError',
      `Couldn't update domain preferences for domain ${domain}. Error: ${error.message}`
    );
  }
}
